"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectedPlanSubItem_1 = require("./SelectedPlanSubItem");
exports.default = SelectedPlanSubItem_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectedPlanSubItem/index.js
// module id = 1405
// module chunks = 8